export const privateRoutes: string[] = ['/accounts', '/orders', '/profile', '/change-password', '/affiliate']
export const authRoutes: string[] = ['/login', '/register', '/reset-password']
export const DEFAULT_LOGIN_REDIRECT: string = '/'
export const DEFAULT_LOGOUT_REDIRECT: string = '/'
export const NO_BREADCRUMB_ROUTES: string[] = ['/', 'collections', '/bo-suu-tap', '/blog']
